import dompurify, { type Config } from 'isomorphic-dompurify'

// Sanitize HTML with dompurify and return a sanitized html string
// Pass in a config object to override the default config
// Example: { ADD_ATTR: ['target'] } to allow target="_blank" on links
export const sanitizeHTML = (html: string, config: Config = {}) =>
  dompurify.sanitize(html, {
    ...config,
    RETURN_DOM: false, // just return the html string
    RETURN_DOM_FRAGMENT: false, // just return the html string
  })
